import { app } from "@/main.js";

export function getHideIcons() {
  return localStorage.getItem("hideIcons") == "true" || false;
}

export function setHideIcons(hideIcons) {
  localStorage.setItem("hideIcons", hideIcons);
  app.apiPost({
    resource: "app/settings",
    data: { key: "hideIcons", value: hideIcons },
  });
}

export function absenceStatusColor(absence) {
  if (!absence || !absence.status.code) return "";
  switch (absence.status.code) {
    case "excused":
      return "success";
    case "halfDay":
      return "info";
    case "justified": // zurückgewiesen (rejected)
      return "success";
    case "pending": // entschuldigt (excused)
      return "info";
    case "present": // unentschuldigt (unexcused)
      return "warning";
    case "unexcused": // gelöscht (deleted)
      return "danger";
    default:
      return "";
  }
}

export function absenceIcon(absence, force) {
  if (!force && getHideIcons()) {
    return "";
  }
  if (!absence || !absence.status.code) return "";
  switch (absence.status.code) {
    case "pending":
      return "mdi-account-clock";
    case "unexcused":
      return "mdi-account-alert";
    default:
      return justificationCategoryIcon(absence.justificationCategory);
  }
}

export function changeLogIcon(type) {
  switch (type.code) {
    case "accountActivate":
      return "mdi-account-check";
    case "accountCreate":
      return "mdi-account-plus";
    case "accountDeactivate":
      return "mdi-account-off";
    case "accountDelete":
      return "mdi-account-minus";
    case "addressChange":
      return "mdi-map-marker";
    case "artsPlusSubjectChange":
    case "bilingualChange":
    case "complementarySubjectChange":
    case "fifthSubjectChange":
    case "languagePlusChange":
    case "majorSubjectChange":
    case "majorSubjectPlusChange":
    case "physicalEducationChange":
    case "secondLanguageChange":
    case "thirdLanguageChange":
      return "mdi-tag";
    case "birthdayChange":
      return "mdi-cake";
    case "citizenshipChange":
      return "mdi-passport";
    case "classTeacherAdd":
      return "mdi-account-plus";
    case "classTeacherRemove":
      return "mdi-account-minus";
    case "codeChange":
      return "mdi-label";
    case "created":
      return "mdi-plus";
    case "currentClassTeacherAdd":
      return "mdi-account-tie";
    case "currentClassTeacherRemove":
      return "mdi-account-tie";
    case "divisionChange":
      return "mdi-account-switch";
    case "emailHomeChange":
      return "mdi-email-outline";
    case "emailSchoolChange":
      return "mdi-email";
    case "employeeCategoryChange":
      return "mdi-account-switch-outline";
    case "employeeNumberChange":
      return "mdi-identifier";
    case "entryDateChange":
      return "mdi-calendar-start";
    case "exitDateChange":
      return "mdi-calendar-end";
    case "firstNameChange":
      return "mdi-tag";
    case "genderChange":
      return "mdi-gender-transgender";
    case "groupAdd":
      return "mdi-account-multiple-plus";
    case "groupRemove":
      return "mdi-account-multiple-minus";
    case "ibanChange":
      return "mdi-bank";
    case "lastNameChange":
      return "mdi-tag";
    case "legalGuardianAdd":
    case "legalGuardianRemove":
    case "legalStatusChange":
      return "mdi-account-child";
    case "legicUidChange":
      return "mdi-printer";
    case "municipalityChange":
      return "mdi-map";
    case "namesakeNumberChange":
      return "mdi-counter";
    case "officialFirstNameChange":
      return "mdi-label";
    case "passwordReset":
      return "mdi-lock-check";
    case "passwordResetRequest":
      return "mdi-lock-remove";
    case "personTypeChange":
      return "mdi-account-sync";
    case "phoneHomeChange":
      return "mdi-phone-classic";
    case "phoneMobileChange":
      return "mdi-cellphone";
    case "phoneWorkChange":
      return "mdi-phone";
    case "placeOfOriginChange":
      return "mdi-home-map-marker";
    case "professionChange":
      return "mdi-account-hard-hat";
    case "roleChange":
      return "mdi-account-tie";
    case "schoolClassChange":
      return "mdi-account-group";
    case "socialSecurityNumberChange":
      return "mdi-card-account-details";
    case "substituteClassTeacherAdd":
      return "mdi-account-plus-outline";
    case "substituteClassTeacherRemove":
      return "mdi-account-minus-outline";
    case "substituteCourseTeacherAdd":
      return "mdi-account-plus-outline";
    case "substituteCourseTeacherRemove":
      return "mdi-account-minus-outline";
    case "tagAdd":
      return "mdi-tag-plus";
    case "tagRemove":
      return "mdi-tag-minus";
    case "titleChange":
      return "mdi-label";
    default:
      return "";
  }
}

export function deviceTypeIcon(type) {
  switch (type.description) {
    case "Notebook":
      return "mdi-laptop";
    case "Beamer":
      return "mdi-projector";
    case "Bluray Player":
      return "mdi-disc";
    case "Multimedia":
      return "mdi-speaker";
    case "Adapter":
      return "mdi-cable-data";
    case "Festplatte":
      return "mdi-harddisk";
    case "USB-Stick":
      return "mdi-usb";
    case "Laptop-Netzteil":
      return "mdi-battery-charging";
    case "Mikrofon":
      return "mdi-microphone";
    case "Headset":
      return "mdi-headset";
    case "DVD-Laufwerk":
      return "mdi-disc";
    default:
      return "mdi-bag-suitcase";
  }
}

export function eventColor(event) {
  if (event.current) {
    return "primary";
  }

  if (event.past) {
    return "grey";
  }
  if (event.canceled) {
    return "danger  ";
  }
  if (event.changed) {
    return "error  ";
  }
  return "success";
}

export function eventIcon(event, force) {
  if (!force && getHideIcons()) {
    return "";
  }
  if (event.canceled) {
    return "mdi-calendar-minus";
  }
  if (event.changed) {
    return "mdi-calendar-edit";
  }
  if (event.staffOnly) {
    return "mdi-calendar-account";
  }

  return "mdi-calendar";
}

export function jobIcon(job) {
  if (!job) {
    return "";
  }
  console.log(job);
  switch (job.name) {
    case "Druckkonti":
      return "mdi-printer";
    case "Evento: Angestellte":
      return "mdi-account-tie";
    case "Evento: Erziehungsberechtigte":
      return "mdi-account-supervisor";
    case "Evento: Klassen":
      return "mdi-account-group";
    case "Evento: Schüler:innen":
      return "mdi-account-school";
    case "Validierung":
      return "mdi-format-list-checks";
  }
}
export function justificationCategoryIcon(justificationType, force) {
  if (!force && getHideIcons()) {
    return "";
  }
  if (!justificationType || !justificationType.code) {
    return "";
  }
  switch (justificationType.code) {
    case "halfDay":
      return "mdi-circle-half-full";
    case "illness":
      return "mdi-emoticon-sick-outline";
    case "injury":
      return "mdi-account-injury";
    case "doctor":
      return "mdi-medical-bag";
    case "death":
      return "mdi-human-male-female-child";
    case "other":
      return "mdi-help";
    case "unknown":
      return "mdi-account-question-outline";
  }
}

export function justificationTypeIcon(justificationCategory, force) {
  if (!force && getHideIcons()) {
    return "";
  }
  if (!justificationCategory || !justificationCategory.code) {
    return "";
  }
  switch (justificationCategory.code) {
    case "halfDayMorning":
    case "halfDayAfternoon":
      return "mdi-circle-half-full";
    case "excuse":
      return "mdi-bed";
  }
}

export function justificationStatusColor(status) {
  if (!status || !status.code) return "";
  switch (status.code) {
    case "created": // erstellt (created)
      return "info";
    case "submitted": // eingereicht (submitted)
      return "error";
    case "rejected": // zurückgewiesen (rejected)
      return "error";
    case "approved": // bewilligt (approved)
      return "success";
    case "accepted": // akzeptiert (accepted)
      return "success";
    case "unexcused": // unentschuldigt (unexcused)
      return "danger";
    case "deleted": // gelöscht (deleted)
      return "grey";
    default:
      return "";
  }
}

export function justificationStatusIcon(status, force) {
  if (!force && getHideIcons()) {
    return "";
  }
  if (!status || !status.code) return "";
  switch (status.code) {
    case "created": // erstellt (created)
      return "mdi-plus";
    case "submitted": // eingereicht (submitted)
      return "mdi-mailbox-open-outline";
    case "rejected": // zurückgewiesen (rejected)
      return "mdi-reply-outline";
    case "approved": // bewilligt (approved)
      return "mdi-clock-check-outline";
    case "accepted": // akzeptiert (accepted)
      return "mdi-check";
    case "unexcused": // unentschuldigt (unexcused)
      return "mdi-close";
    case "deleted": // gelöscht (deleted)
      return "mdi-delete-outline";
    default:
      return "";
  }
}

export function lessonStatusColor(status) {
  if (!status || !status.code) return "grey";
  switch (status.code) {
    case "asPlanned":
      return "success";
    case "canceled":
      return "danger";
    case "canceledByEvent":
      return "error";
    case "commented":
      return "info";
    case "inserted":
      return "success";
    case "roomChange":
      return "warning";
    default:
      return "";
  }
}

export function lessonStatusIcon(status, force) {
  if (!force && getHideIcons()) {
    return "";
  }
  if (!status || !status.code) return "";
  switch (status.code) {
    case "asPlanned":
      return "";
    case "canceled":
      return "mdi-minus-thick";
    case "canceledByEvent":
      return "mdi-minus-thick";
    case "commented":
      return "mdi-comment-outline";
    case "inserted":
      return "mdi-plus-thick";
    case "roomChange":
      return "mdi-map-marker";
    default:
      return "";
  }
}

export function studentDutyIcon(tag) {
  if (!tag) return "mdi-square";
  switch (tag.code) {
    case "studentDutyEnvironmentalGroup":
      return "mdi-tree";
    case "studentDutySpeaker":
      return "mdi-account-multiple";
    case "studentDutyStudentOrganisationBoard":
    case "studentDutyStudentOrganisationDelegate":
    case "studentDutyStudentOrganisationDivision":
      return "mdi-bank";
    case "studentDutyTechnicalSupport":
      return "mdi-wrench";
    default:
      return "mdi-square";
  }
}

export function studentSpecialIcon(special) {
  if (!special) return "mdi-square";
  switch (special.code) {
    case "guest": // Gast
      return "mdi-earth";
    case "hospitium": // Hospitant:in
      return "mdi-earth-plus";
    case "exchangeDomestic": // Austauschschüler:in Schweiz
      return "mdi-earth-arrow-left";
    case "future": // Eintritt
      return "mdi-import";
    case "disabilityCompensation": // Nachteilsausgleich
      return "mdi-clock-plus-outline";
    default:
      return "mdi-square";
  }
}

export function subjectIcon(subject, force) {
  if (!force && getHideIcons()) {
    return "";
  }
  if (!subject || !subject.code) {
    return "";
  }
  const subjectCode = subject.code
    .replace("EF ", "")
    .replace("SF ", "")
    .replace(" PR", "")
    .trim();
  if (subjectCode.startsWith("NExt")) {
    //  TODO: nExt-subjectcode einfügen
    return "mdi-nature-people";
  }
  switch (subjectCode) {
    case "A":
      return "mdi-weather-night";
    case "AR":
      return "mdi-account-multiple-outline";
    case "AM":
    case "PAM":
      return "mdi-math-compass";
    case "B":
    case "Be":
    case "Bf":
      return "mdi-flower";
    case "BAND":
      return "mdi-guitar-electric";
    case "BB":
      return "mdi-saxophone";
    case "BG":
    case "BG+":
    case "BGA":
    case "BGi":
    case "BGA2":
      return "mdi-palette";
    case "BGA1":
      return "mdi-camera-iris";
    case "BSKM":
      return "mdi-abacus";

    case "C":
    case "CP+":
      return "mdi-flask-outline";
    case "BC":
      return "mdi-microscope";
    case "CAE":
    case "CPE":
    case "DALF":
    case "DELF":
      return "mdi-certificate";
    case "CAN":
      return "mdi-laptop";
    case "CHOR":
      return "mdi-account-music";
    case "D":
    case "BSKD":
    case "DaZ1":
    case "DaZ2":
    case "Dba":
      return "mdi-book-open-variant";
    case "E":
      return "mdi-tea";
    case "F":
    case "Fb":
    case "Fba":
    case "FfZ1":
    case "FfZ2":
    case "SKF":
      return "mdi-eiffel-tower";
    case "FKD":
    case "FKM":
      return "mdi-cube-outline";
    case "G":
    case "Ge":
    case "Gf":
      return "mdi-newspaper-variant-outline";
    case "GG":
      return "mdi-earth";
    case "I":
      return "mdi-pizza";

    case "IN":
    case "IN+":
      return "mdi-chip";

    case "IN PR":
      return "mdi-memory";
    case "TK":
      return "mdi-led-on";

    case "KS":
      return "mdi-account-group";
    case "L":
      return "mdi-pillar";
    case "LIT":
      return "mdi-typewriter";
    case "M":
    case "Me":
    case "Mf":
    case "M PV":
      return "mdi-calculator-variant";
    case "M+":
      return "mdi-matrix";
    case "Mba":
      return "mdi-abacus";
    case "MSU":
      return "mdi-account-tie";
    case "MU":
    case "MU+":
    case "MUi":
      return "mdi-music";

    case "NAT":
      return "mdi-scissors-cutting";
    case "ORCH":
      return "mdi-instrument-triangle";
    case "P":
      return "mdi-cog";

    case "PH":
    case "PP":
    case "PPe":
    case "PPP":
      return "mdi-head-dots-horizontal";

    case "POL":
      return "mdi-account-voice";
    case "R":
      return "mdi-scale-balance";
    case "RU":
      return "mdi-teddy-bear";
    case "S":
      return "mdi-guitar-acoustic";

    case "SP":
    case "SP F":
    case "SP M":
    case "SP G":
      return "mdi-volleyball";

    case "RED":
      return "mdi-newspaper";

    case "RL":
    case "RLe":
      return "mdi-dots-circle";

    case "THAT":
    case "THB":
      return "mdi-drama-masks";

    case "BW":
    case "EWR":
    case "VW":
    case "WR":
    case "WR+":
      return "mdi-finance";

    case "VEMS":
      return "mdi-medical-bag";
    case "YOGA":
      return "mdi-yoga";
    default:
      return "";
  }
}

export function noteIcon(note, force) {
  if (!force && getHideIcons()) {
    return "";
  }
  if (!note || !note.type || !note.type.code) {
    return "";
  }
  switch (note.type.code) {
    case "homework":
      return "mdi-progress-check";
    case "information":
      return "mdi-text";
    case "exam":
      if (note.plannedExam) {
        return "mdi-octagram";
      }
      return "mdi-octagram-outline";
    default:
      return "";
  }
}

export function noteColor(note) {
  if (!note || !note.type || !note.type.code) {
    return "";
  }
  switch (note.type.code) {
    case "exam":
      return note.plannedExam ? "danger" : "error";
    case "information":
      return "info";
    case "homework":
      return "success";
    default:
      return "";
  }
}

export function holidayIcon(holiday, force) {
  if (!force && getHideIcons()) {
    return "";
  }
  if (!holiday) {
    return "";
  }
  switch (holiday.name) {
    case "Herbstferien":
      return "mdi-leaf";
    case "Winterferien":
      return "mdi-pine-tree";
    case "Februarferien":
      return "mdi-snowboard";
    case "Frühlingsferien":
      return "mdi-flower";
    case "Sommerferien":
      return "mdi-beach";
    default:
      return "";
  }
}

export function reportIcon(report, force) {
  if (!force && getHideIcons()) {
    return "";
  }
  if (report.fileType === "xlsx") {
    return "mdi-file-excel-box";
  }
  if (report.fileType === "pdf") {
    return "mdi-file-pdf-box";
  }
  if (report.fileType === "csv") {
    return "mdi-file-table-box";
  }
  if (report.fileType === "zip") {
    return "mdi-folder-zip";
  }
  return "mdi-help-box";
}

export function reportColor(report) {
  if (report.fileType === "xlsx") {
    return "#1D6F42";
  }
  if (report.fileType === "pdf") {
    return "#F40F02";
  }
  if (report.fileType === "csv") {
    return "#7BBFCC";
  }
  if (report.fileType === "zip") {
    return "#F8D775";
  }
  return "";
}
